<template>
  <div id="download">
    <div class="poster">
      <img src="@/common/img/xiazzx.png" alt="">
    </div>
    

    <div class="classTitle">
      <p class="title" >检验检测公告/公示</p>
    </div>

    <div class="display-list">
      <div 
        v-for="article in articles" 
        :key="article.id" 
        class="article-item" 
        @click="goDetail(article)"
      >
        <div class="article-info">
          <div class="article-title">{{ article.title }}</div>
          <div class="article-time">{{ article.time }}</div>
        </div>
        <div class="article-action">
          <button class="btn-detail" @click.stop="previewAttachment(article.img)">了解详情 +</button>
        </div>
      </div>
    </div>

    <el-pagination
      v-show="total > 0"
      @current-change="handleCurrentChange"
      :current-page.sync="queryParams.pageNum"
      :page-size="10"
      layout="prev, pager, next, jumper"
      :total="total"
      background
      class="pagination-container">
    </el-pagination>

    <p class="empty-class" v-if="articles && articles.length <= 0" :image-size="200">暂无数据 ～～～</p>
  </div>
</template>

<script>
import { listUp } from "@/api/up"
export default {
  name: 'download',

  components: {
  },

  data () {
    const baseUrl = process.env.VUE_APP_BASE_API

    return {
      baseUrl: baseUrl,
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      articles: [],
      selectedBtn: 0,
      total: 0
    }
  },

  mounted () {
    this.$nextTick(function () {
      this.$store.state.el_.scrollTop = 0
    })
  },

  created() {
    this.getList()
  },

  methods: {
    /** 查询报告上传公示列表 */
    getList() {
      listUp(this.queryParams).then(response => {
        console.log(response)
        this.articles = response.rows
        this.total = response.total
        this.loading = false
      })
    },
    goDetail(item) {
      this.$router.push({
        path: '/solutionDetail',
        query: {
          id: item.id
        }
      })
    },

    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.queryParams.pageNum = val
      this.getList()
    },
    
    // 预览附件
    previewAttachment(url) {
      window.open(process.env.VUE_APP_BASE_API + url, '_blank');
    },
  }
}
</script>

<style lang='less' scoped>
#download {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .poster {
    width: 100%;

    img {
      width: 100%;
    }
  }

  ul {
    padding: 0;
  }
  .isShow {
    // background-color: red;
    color: red;
  }

  .empty-class {
    color: #909399;
    font-size: 16px;
    padding: 30px 0;
  }
  
  .pagination-container {
    margin-top: 20px;
    margin-bottom: 30px;
    text-align: center;
  }
}

@media screen and (min-width: 768px) {
  .display-list {
    width: 1170px;
  }

  .classTitle {
    width: 1170px;
  }

  .display-item {
    div {
      width: 300px;
      height: 242px;
      overflow: hidden;
    }

    p {
      width: 300px;
    }
  }
}
@media screen and (max-width: 768px) {
  .display-list {
    width: 100%;
  }

  .classTitle {
    width: 100%;

    .title {
      font-size: 20px !important;
      line-height: 20px !important;
    }
  }

  .display-item {
    div {
      width: 170px;
      height: 140px;
      overflow: hidden;
    }
    p {
      width: 170px;
    }
  }
}

.container {
  width: 100%;

  .btnContent {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 5px;
    box-sizing: border-box;

    .btnBox1 {
      display: flex;
      align-items: center;

      .el-button {
        font-size: 18px;
      }
    }

    .btnBox2 {
      display: flex;
      align-items: center;

      .el-button {
        font-size: 15px;
      }
    }

    .el-button {
      padding: 10px 0;
      color: black;

      &:hover {
        color: red;
      }
    }
  }
}

.classTitle {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 10px;
  box-sizing: border-box;
  border-bottom: 2px solid #409EFF;
  margin-bottom: 10px;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 50%;
    transform: translateX(-50%);
    width: 100px;
    height: 4px;
    background-color: #409EFF;
    border-radius: 2px;
  }

  .title {
    font-size: 32px;
    font-weight: bold;
    line-height: 56px;
    color: #303133;
    letter-spacing: 2px;
    margin: 10px 0;
    position: relative;
    text-align: center;
    
    &:before, &:after {
      content: '';
      display: inline-block;
      width: 30px;
      height: 2px;
      background-color: #409EFF;
      vertical-align: middle;
      margin: 0 15px;
    }
  }

  .content {
    font-size: 14px;
    color: #909399;
  }
}

.display-list {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1170px;
  padding: 30px 15px;
  box-sizing: border-box;
}
.article-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  margin-bottom: 15px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.03);
}

.article-item:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
  border-color: #d9ecff;
}

.article-info {
  flex: 1;
  padding-right: 20px;
}

.article-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;
  color: #303133;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.article-time {
  font-size: 13px;
  color: #909399;
  display: flex;
  align-items: center;
}

.article-action {
  margin-left: 15px;
  display: flex;
  
  .btn-detail {
    padding: 8px 16px;
    background-color: #409EFF;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s;
    
    &:hover {
      background-color: #66b1ff;
    }
  }
}
</style>
